import React from 'react';
import {useNavigate} from 'react-router-dom';

import '../index.style.less';
import {Button} from 'antd';
import AppAnimateGroup from '@crema/core/AppAnimateGroup';
import AppPageMetadata from '@crema/core/AppPageMetadata';
import {ReactComponent as Logo} from '../../../assets/icon/401.svg';
import IntlMessages from '@crema/utility/IntlMessages';

const Error401 = () => {
  const navigate = useNavigate();

  const onGoBackToHome = () => {
    navigate('/');
  };

  return (
    <AppAnimateGroup type='bottom'>
      <AppPageMetadata title='Unauthorized' />
      <div className='error-container' key='a'>
        <div className='error-img'>
          <Logo />
        </div>
        <div className='error-content'>
          <h3>
            <IntlMessages id='error.401Error' />
          </h3>
          <div className='error-para'>
            <p className='mb-0'>
              <IntlMessages id='error.401Message' />
            </p>
          </div>
          <Button type='primary' className='error-btn' onClick={onGoBackToHome}>
            <IntlMessages id='error.goBackToHome' />
          </Button>
        </div>
      </div>
    </AppAnimateGroup>
  );
};

export default Error401;
